import { type CreateSignedDataInput, type CreateSigningKeyChangeInput } from '../../../API';
import { type DbSyncerUpDefinition } from '../syncHelpers';
import { getStandardSyncerFields } from '../syncHelpers';
import { type DbCreated, type WithId } from '../types';

let counter = 0;

const signedDataItemFields = 'id';

export const signedDataToDb: DbSyncerUpDefinition = (input: CreateSignedDataInput & WithId) => {
    const c = ++counter;
    const commandName = 'createSignedData';
    const inputType = 'CreateSignedDataInput';
    const { mutationName, inputKey, query } = getStandardSyncerFields(commandName, c, signedDataItemFields);
    return {
        query,
        input,
        inputKey,
        inputType,
        mutationName,
        remoteToLocalTransform: signedDataTransform,
        queryName: 'getSignedData',
        appendOnly: true,
    };
};

const signedDataTransform = (input: CreateSigningKeyChangeInput & DbCreated): { id: string; deleted: boolean } => {
    // only delete local data
    return { id: input.id, deleted: true };
};
